






















import { Component, Prop, Vue } from 'vue-property-decorator';
import { FormRulesVO, FullscreenButtonMargin } from '@/model/FormWheel';
import topIcon from '@/assets/img/margin/top.svg';
import rightIcon from '@/assets/img/margin/right.svg';
import bottomIcon from '@/assets/img/margin/bottom.svg';
import leftIcon from '@/assets/img/margin/left.svg';
import { FullscreenFormPage } from '@/views/wheelOfFortune/utils/fullscreenBackgroundLayout';

type Direction = keyof FullscreenButtonMargin;

@Component
export default class FullscreenButtonMarginSetting extends Vue {
  @Prop({ required: true }) rules!: FormRulesVO;
  @Prop({ required: true }) page!: FullscreenFormPage;

  directions: Direction[] = ['top', 'left', 'bottom', 'right'];
  icons: Record<Direction, string> = { top: topIcon, right: rightIcon, bottom: bottomIcon, left: leftIcon };

  getValue(direction: Direction): number {
    return this.rules.fullscreenMainButtonMargins?.[this.page]?.[direction] ?? 0;
  }

  changeDirection(direction: Direction, value: number): void {
    if (!this.rules.fullscreenMainButtonMargins) {
      this.$set(this.rules, 'fullscreenMainButtonMargins', {});
    }
    const margins = this.rules.fullscreenMainButtonMargins!;
    if (!margins[this.page]) {
      this.$set(margins, this.page, {});
    }
    this.$set(margins[this.page]!, direction, Math.min(100, Math.max(0, Math.round(Number(value) || 0))));
    this.$emit('change');
  }
}
